/* eslint-disable no-unused-vars */
import { QUERY_PARAMETERS } from "@/constants";

function addDaysToDate(date, days) {
  let d = new Date(date.valueOf());
  return new Date(d.setDate(d.getDate() + days));
}

export const INVOICE_LOAD_QUERY_PARAMETERS = (function () {
  const now = new Date();
  const start_of_today = new Date(now.getFullYear(), now.getMonth(), now.getDay());
  const end_of_today = addDaysToDate(now, 1);

  const one_month_ago = addDaysToDate(now, -30);
  const three_months_later = addDaysToDate(now, 90);
  const end_of_year = new Date(now.getFullYear(), 11, 31);

  return Object.freeze({
    [QUERY_PARAMETERS.PAGE_NO]: 1,
    [QUERY_PARAMETERS.START_TIME]: new Date(2022, 0, 1),
    [QUERY_PARAMETERS.END_TIME]: new Date(2023, 11, 31),
    [QUERY_PARAMETERS.ISSUE_START_TIME]: new Date(2022, 0, 1),
    [QUERY_PARAMETERS.ISSUE_END_TIME]: new Date(2023, 11, 31),
    [QUERY_PARAMETERS.SORT]: "-created_at",
  });
}());
  
export const ACTIVITY_LOGS_LOAD_QUERY_PARAMETERS = (function () {
  const now = new Date();
  const start_of_today = new Date(now.getFullYear(), now.getMonth(), now.getDay());
  const end_of_today = addDaysToDate(now, 1);

  const one_month_ago = addDaysToDate(now, -30);
  const three_months_later = addDaysToDate(now, 90);
  const end_of_year = new Date(now.getFullYear(), 11, 31);

  return Object.freeze({
    [QUERY_PARAMETERS.PAGE_NO]: 1,
    [QUERY_PARAMETERS.START_TIME]: new Date(2022, 0, 1),
    [QUERY_PARAMETERS.END_TIME]: new Date(2023, 11, 31),
  });
}());


export const CUSTOMERS_LOAD_QUERY_PARAMETERS = (function () {
  return Object.freeze({
    [QUERY_PARAMETERS.PAGE_NO]: 1,
  });
}());